<script setup>
//  assets/project/src/components/Base/StarsComponent.vue
import { ref, toRefs, onMounted, defineProps, watch, defineEmits } from 'vue';
import StarActive from "@/components/Base/StarActive.vue";
import StarInActive from "@/components/Base/StarInActive.vue";

const props = defineProps({
	modelValue: {
		type: Number,
		default: 0
	},
	maxStars: {
		type: Number,
		default: 10
	}
});
const {modelValue} = toRefs(props);
const stars = ref([]);

const emit = defineEmits(['update:modelValue'])


function activateStars(index) {
	//Активные только с нулевого элемента до выбранного
	for (let i = 0; i <= index; i++) {
		if (stars.value[i]) {
			stars.value[i].type = StarActive;
		}
	}
	for (let i = index + 1; i < props.maxStars; i++) {
		if (stars.value[i]) {
			stars.value[i].type = StarInActive;
		}
	}
}

function deactivateStars() {
	stars.value.forEach((star, index) => {
		star.type = index < 0 ? StarActive : StarInActive;
	});
}

function changeModelValue(index) {
	emit('update:modelValue', index+1);
}

function setDefault() {
	stars.value = Array.from({ length: props.maxStars }, (_, index) => ({
		type: index < modelValue.value ? StarActive : StarInActive
	}));
}

function leaveStarsBlock() {
	setDefault();
}

onMounted(() => {
	setDefault();
});



</script>

<template>
    <div class="stars__wrapper" @mouseleave="leaveStarsBlock">
        <div v-for="(star, index) in stars" :key="index"  @mouseover="activateStars(index)" @mouseleave="deactivateStars">
            <component @click="changeModelValue(index)" :is="star.type"></component>
        </div>
    </div>
</template>

<style scoped>
.stars__wrapper {
    display: flex;
}
</style>
